import * as React from "react";
import { forwardRef } from "react";
const SvgBlocked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 0a8 8 0 0 1 5.826 13.48.9.9 0 0 1-.346.345A8 8 0 0 1 2.174 2.52a.9.9 0 0 1 .345-.345A7.97 7.97 0 0 1 8 0M3.016 4.273a6.222 6.222 0 0 0 8.71 8.71zM8 1.778c-1.398 0-2.688.46-3.727 1.238l8.71 8.71A6.222 6.222 0 0 0 8 1.778", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgBlocked);
export { ForwardRef as ReactComponent };
